<template>
  <el-dialog title="填写复盘会时间"
             :visible.sync="dialogVisible"
             width="60%"
             top="20px"
             :close-on-click-modal="false"
             destroy-on-close
             @closed="progressAfterDialogClosed">
    <el-form label-width="120px" label-position="left">
      <el-form-item label="无需复盘会">
        <el-switch v-model="form.no_review_meeting">
        </el-switch>
        <span class="form-item-tip">常规项目可不需要填写复盘会时间，开启后将跳过时间填写</span>
      </el-form-item>
      <el-form-item :label="`第${nextSeqNo}次复盘会`"
                    prop="newMeetingTime"
                    v-if="!form.no_review_meeting">
        <el-date-picker v-model="newMeetingTime"
                        type="datetime"
                        :picker-options="dateTimeLteTodayOptions"
                        format="yyyy-MM-dd HH:mm"
                        value-format="yyyy-MM-dd HH:mm"
                        placeholder="请选择复盘会的时间"
                        :default-time="defaultTime"
                        clearable>
        </el-date-picker>
      </el-form-item>

      <el-form-item label="本次参会人"
                    prop="attendees"
                    v-show="!form.no_review_meeting">
        <WecomDepartmentTree ref="attendeeTree"
                             v-if="dialogVisible"
                             :show-checkbox="true"
                             :default-expand-all="false"
                             :show-filter="true"
                             @check="onAttendeeCheck"/>
        <div v-if="selectedAttendees.length"
             class="attendee-tags">
          <el-tag v-for="a in selectedAttendees"
                  :key="a.key"
                  type="info"
                  size="mini"
                  style="margin-right: 5px"
                  closable
                  @close="removeAttendee(a)">{{ a.name }}
          </el-tag>
        </div>
        <span class="form-item-tip">勾选部门代表该部门下全部账号参会；也可仅勾选具体参会人</span>
      </el-form-item>

      <el-form-item label="文件上传" :rules="[{ required: true, message: '请上传Excel文件' }]">
        <span class="form-item-tip">复盘会议纪要、相关文档等</span>
        <el-upload ref="uploadRef"
                   class="no-transition-upload"
                   action=""
                   :auto-upload="false"
                   :on-change="handleFileChange"
                   drag
                   list-type="text">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text"
               style="font-size: 12px;line-height: 1.2;">
            将文件拖到此处，或<em>点击上传</em><br>
            文件多于20个时建议上传zip压缩文件
          </div>
          <template slot="file"
                    slot-scope="{ file }">
            <div class="upload-file-item">
              <a class="upload-file-link"
                 href="javascript:void(0)"
                 @click.prevent.stop="downloadProgressAttachFile(file)">
                {{ file.name }}</a>
              <i class="el-icon-download"
                 style="margin-right: 6px;cursor: pointer;"
                 @click="downloadProgressAttachFile(file)"></i>
              <i class="el-icon-delete"
                 style="cursor: pointer;"
                 @click="removeFile(file)"></i>
            </div>
          </template>
        </el-upload>
      </el-form-item>
      <el-form-item label-width="0px">
        <el-card v-if="submittedMeetingList.length > 0">
          <div slot="header"
               class="clearfix">
            <span>历史记录</span>
          </div>
          <el-row v-for="(item, index) in submittedMeetingList" :key="index" style="margin-bottom: 20px">
            <div v-if="item.hasOwnProperty('submit_admin_id')">
              <el-tag type="">第 {{ item.seq_no }} 次</el-tag>
              <span style="margin-left: 20px">
              <i class="el-icon-time"></i>
              {{ item.review_meeting_time }}丨填写人: {{ item.submit_admin_name }}
            </span>
              <el-button style="margin-left: 20px" size="mini" type="primary" @click="innerVisible = true">查看详情</el-button>
            </div>
          </el-row>
        </el-card>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary"
                 @click="onSubmit">提交
      </el-button>
    </div>
    <el-dialog
      width="60%"
      title="复盘会详情查看"
      :visible.sync="innerVisible"
      append-to-body>
      <review-meeting-view
        :project-id="projectId"
        :fullNode="fullNode"/>
    </el-dialog>
  </el-dialog>
</template>

<script>
import userWorkInfoMixin from '@views/user-workinfo/user-workinfo.mixin.js'
import projectMixins from '@views/project/project.mixins'
import WecomDepartmentTree from '@views/wecom/components/department-tree.vue'
import ReviewMeetingView from '@views/project/node-views/ReviewMeetingView.vue'

export default {
  components: {WecomDepartmentTree, ReviewMeetingView},
  mixins: [userWorkInfoMixin, projectMixins],
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    projectId: {
      type: String,
      default: '0',
    },
    fullNode: {
      type: Object,
      default: () => ({}),
    },
  },
  data () {
    return {
      form: {
        no_review_meeting: false,
        review_meeting_files: [],
      },
      submittedMeetingList: [],
      newMeetingTime: null,
      defaultTime: '00:00:00',
      checkedTick: 0,
      innerVisible: false,
    }
  },
  created () {},
  computed: {
    selectedAttendees () {
      // 依赖 checkedTick 触发重算（$refs 非响应式）
      void this.checkedTick
      const treeRef = this.$refs.attendeeTree
      console.log(treeRef)
      if (!treeRef) return []
      return (treeRef.getCheckedNodes() || []).filter(n => n.type === 'user')
    },
    ...Vuex.mapState({
      loginUser: state => state.login.user,
    }),
    dialogVisible: {
      get () {
        return this.visible
      },
      set (val) {
        this.$emit('update:visible', val)
      },
    },
    nextSeqNo () {
      const list = this.submittedMeetingList
      return list.length > 0 ? list[list.length - 1].seq_no + 1 : 1
    },
  },
  watch: {
    visible: {
      handler (val) {
        if (val) {
          this.initAttr(this.fullNode.project_node || {})
        }
      },
      immediate: true,
    },
  },
  methods: {
    // 树勾选变化：触发 selectedAttendees 重算（数据以树的勾选状态为准）
    onAttendeeCheck () {
      this.checkedTick++
    },
    // 支持从列表直接移除已选参会人
    removeAttendee (attendee) {
      const treeRef = this.$refs.attendeeTree
      if (!treeRef) return
      const elTree = treeRef.getTreeRef()
      if (elTree) elTree.setChecked(attendee.key, false)
      this.checkedTick++
    },
    initAttr (projectNode) {
      this.form.no_review_meeting = _.get(projectNode, 'node_result.no_review_meeting', false)
      this.form.review_meeting_files = _.get(projectNode, 'node_result.review_meeting_files', []).map(item => ({...item}))
      this.submittedMeetingList = _.get(projectNode, 'node_result.review_meeting_list', []).map(item => ({...item}))
      this.newMeetingTime = null

      this.checkedTick++
      this.$nextTick(() => {
        this.$refs.uploadRef.uploadFiles = this.form.review_meeting_files.map(f => ({
          name: f.name,
          url: f.url,
          status: 'success',
          uid: f.uid || Date.now() + Math.random()
        }))
      })

      const now = new Date()
      const hh = String(now.getHours()).padStart(2, '0')
      const mm = String(now.getMinutes()).padStart(2, '0')
      this.defaultTime = `${hh}:${mm}:00`
    },
    async handleFileChange (file, fileList) {
      try {
        await this.withLoading(async () => {
          const url = await this.doAdminDirectUploadFile(file.raw)
          if (url) {
            file.url = url
            this.form.review_meeting_files.push(this.formatStandardFile(file, this.loginUser))
          } else {
            this.$refs.uploadRef.handleRemove(file)
          }
        }, '文件上传中...')
      } catch (e) {
        this.$message.error('添加至文件列表失败，原因: ' + e)
        this.$refs.uploadRef.handleRemove(file)
      }
    },
    async removeFile (file) {
      try {
        await this.$confirm(`确定要移除文件【${file.name}】吗？`, '移除文件警告')
        // 从 upload 列表移除
        this.$refs.uploadRef.handleRemove(file)
        const index = this.form.review_meeting_files.findIndex(f => f.name === file.name && f.url === file.url)
        if (index > -1) {
          this.form.review_meeting_files.splice(index, 1)
        }
      } catch (e) {
        // 用户取消，不做任何操作
      }
    },
    async onSubmit () {
      if (this.form.review_meeting_files.length === 0) {
        this.$message.error('必须上传文件附件')
        return
      }
      const meetingList = [...this.submittedMeetingList]
      if (!this.form.no_review_meeting) {
        if (!this.newMeetingTime) {
          this.$message.error('第' + this.nextSeqNo + '次复盘会时间不得留空')
          return
        }
        if (this.selectedAttendees.length === 0) {
          this.$message.error('请选择本次参会人')
          return
        }
        meetingList.push({
          seq_no: this.nextSeqNo,
          version: 2,
          review_meeting_time: this.newMeetingTime ? this.newMeetingTime + ':00' : null,
          attendees: this.selectedAttendees.map(a => ({ // 参会人
            type: a.type,
            key: a.key,
            userid: a.userid || '',
            name: a.name,
          })),
        })
      }

      const params = {
        id: this.projectId,
        no_review_meeting: this.form.no_review_meeting,
        review_meeting_files: this.form.review_meeting_files,
        review_meeting_list: meetingList,
      }
      await this.withLoading(async () => {
        try {
          const res = await request.common('addReviewMeetingTimeApi', params)
          this.progressDialogAfterSubmitSuccess(res.data)
          this.$message.success('复盘会时间保存成功')
        } catch (error) {
          this.$message.error(error.message || '保存失败')
        }
      })
    },
  },
}
</script>

<style lang="scss"
       scoped>
.form-item-tip {
  font-size: 12px;
  color: #909399;
  margin-top: 4px;
}
</style>



// WEBPACK FOOTER //
// src/views/project/components/ReviewMeetingDialog.vue